import { Component, OnInit, Renderer2  } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { SharedCoreModule } from '@shared/modules/shared-core/shared-core.module';
import { HeaderComponent } from '@shared/components/header/header.component';
import { UtilityService } from '@shared/services/utilityService/utility.service';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from '@shared/services/storageService/storage.service';
import { configuration } from '@shared/properties/configuration';
import { MatIconRegistry } from '@angular/material/icon';
import { registerLocaleData } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import localeEn from '@angular/common/locales/en';
import localeFr from '@angular/common/locales/fr';


@Component({
  selector: 'app-root',
  // standalone: true,
  imports: [RouterOutlet, RouterModule, SharedCoreModule, HeaderComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  sriHash: string | null = null;
  url = 'https://cmp.osano.com/16CFuWSuPfE35eNP/9e9b833b-6d71-40f8-ae60-86ccc21da26b/osano.js';

  constructor(
    private utilityService: UtilityService,
    private renderer: Renderer2,
    private translate: TranslateService,
    private storage: StorageService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    // Configure supported and default languages
    const supported = configuration.applicationLocale.supportedList.map(l => l.key);
    const defaultLang = configuration.applicationLocale.default;
    this.translate.addLangs(supported);
    this.translate.setDefaultLang(defaultLang);

    // Determine initial language: session -> browser -> default
    const stored = this.storage.getObject('currentLanguage', configuration.storageTypes.SessionStorage);
    const browser = (navigator.language || navigator['userLanguage'] || defaultLang).slice(0, 2);
    const initial = (stored && supported.includes(stored))
      ? stored
      : (supported.includes(browser) ? browser : defaultLang);
    this.translate.use(initial);

    registerLocaleData(localeEn, 'en');
    registerLocaleData(localeFr, 'fr');

    this.matIconRegistry.addSvgIcon('mmc-funnel',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/funnel.svg')
    ).addSvgIcon(
      'mmc-search',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/search.svg')
    ).addSvgIcon(
      'mmc-import',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/import.svg')
    ).addSvgIcon(
      'mmc-trash',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/trash.svg')
    ).addSvgIcon(
      'mmc-select',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/select.svg')
    ).addSvgIcon(
      'mmc-checklist',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/checklist.svg')
    ).addSvgIcon(
      'mmc-history',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/history.svg')
    ).addSvgIcon(
      'mmc-equalizer',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/equalizer.svg')
    ).addSvgIcon(
      'mmc-power-switch',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/power-switch.svg')
    ).addSvgIcon(
      'mmc-question',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/question.svg')
    ).addSvgIcon(
      'mmc-check',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/check.svg')
    ).addSvgIcon(
      'mmc-home',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/home.svg')
    ).addSvgIcon(
      'mmc-tab-checklist',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/checklist2.svg')
    ).addSvgIcon(
      'mmc-files',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/files.svg')
    ).addSvgIcon(
      'mmc-question-circle',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/question-circle.svg')
    ).addSvgIcon(
      'mmc-check-circle',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/check-circle.svg')
    ).addSvgIcon(
      'mmc-plus',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/plus.svg')
    ).addSvgIcon(
      'mmc-business-card',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/business-card.svg')
    ).addSvgIcon(
      'mmc-chevron-right',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/chevron-right.svg')
    ).addSvgIcon(
      'mmc-chevron-left',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/chevron-left.svg')
    ).addSvgIcon(
      'mmc-upload2',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/upload2.svg')
    ).addSvgIcon(
      'mmc-files-compare',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/files-compare.svg')
    ).addSvgIcon(
      'mmc-first',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/first.svg')
    ).addSvgIcon(
      'mmc-last',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/last.svg')
    ).addSvgIcon(
      'mmc-next',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/next-frame.svg')
    ).addSvgIcon(
      'mmc-previous',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/previous-frame.svg')
    ).addSvgIcon(
      'mmc-calendar',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/calendar.svg')
    ).addSvgIcon(
      'mmc-calendar-cross',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/calendar-cross.svg')
    ).addSvgIcon(
      'mmc-file-excel',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/file-excel.svg')
    ).addSvgIcon(
      'mmc-file-pdf',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/file-pdf.svg')
    ).addSvgIcon(
      'mmc-file-powerpoint',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/file-powerpoint.svg')
    ).addSvgIcon(
      'mmc-file-word',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/file-word.svg')
    ).addSvgIcon(
      'mmc-sort-size-desc',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/sort-size-desc.svg')
    ).addSvgIcon(
      'mmc-download-circle',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/download-circle.svg')
    ).addSvgIcon(
      'mmc-refresh',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/transfer-circle.svg')
    ).addSvgIcon(
      'mmc-file-download',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/file-download.svg')
    );
  }

  async ngOnInit() {
    this.sriHash = await this.utilityService.generateSriHash(this.url);
    this.appendScript();
  }

    appendScript() {
    const script = this.renderer.createElement('script');
    script.src = this.url;
    script.integrity = this.sriHash;
    script.crossOrigin = 'anonymous';
    script.async = true; // Optional: Load the script asynchronously
    this.renderer.appendChild(document.head, script);
  }

}
